import { render, staticRenderFns } from "./AssetReplaceNotAllowedPopUp.vue?vue&type=template&id=7fc159c9&lang=pug"
import script from "./AssetReplaceNotAllowedPopUp.vue?vue&type=script&lang=js"
export * from "./AssetReplaceNotAllowedPopUp.vue?vue&type=script&lang=js"
import style0 from "./AssetReplaceNotAllowedPopUp.vue?vue&type=style&index=0&id=7fc159c9&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports